import React from 'react'
import { FFEDocument, Group } from '../../types/ffe'
import { PrintLineItem } from './Document/PrintLineItem'
import { PrintGroup } from './Document/PrintGroup'

interface Props {
  document: FFEDocument
}

export const PrintLineItems: React.FC<Props> = ({ document }) => {
  const { lineItems, groups, materials, settings: documentSettings } = document

  const ungroupedLineItems = lineItems.filter((item) => !item.groupId)
  const ungroupedGroups = groups.filter((group) => !group.groupId)

  return (
    <table border={0} rules='none' className="w-full mt-8 h-[1px]">
      <thead className="border-b-2">
        <tr>
          <th className="text-left py-2">Item</th>
          <th className="text-right">Qty</th>
          {documentSettings.showClientPrices && (
            <th className="text-right">Price</th>
          )}
          {documentSettings.showClientPrices && (
            <th className="text-right">Total</th>
          )}
        </tr>
      </thead>
      <tbody>
        {ungroupedGroups.map((group: Group) => (
          <PrintGroup
            key={group.id}
            group={group}
            document={document}
            depth={0}
          />
        ))}
        {ungroupedLineItems.map((item) => (
          <PrintLineItem
            key={item.id}
            item={item}
            materials={materials}
            documentSettings={document.settings}
            depth={0}
          />
        ))}
      </tbody>
    </table>
  )
}
